import { useEffect, useRef, useState } from 'react';
import useLocales from '../../hooks/useLocales';
import { useModalError } from '../../hooks/useModalError';
import LoadingSpinner from '../loadingSpinner';
import { ReSendCodeDiv, ReSendCodeWrap } from './styles';

enum DownTimeStatus {
  /**
   * Not started
   */
  NotStarted = 0,
  /**
   * In progress
   */
  InProgress = 1,
  /**
   * End
   */
  End = 2,
  /**
   * Stop
   */
  Stop = 3,
}

const DownTime = 60;

const ReSend = ({ reSendCode }: { reSendCode: () => void }) => {
  const locales = useLocales();

  const [downTimeStatus, setDownTimeStatus] = useState(DownTimeStatus.NotStarted);
  const { showError } = useModalError();
  const [downTime, setDownTime] = useState(DownTime);
  const [loading, setLoading] = useState(false);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const downTimeCount = () => {
    setDownTime(DownTime);
    setDownTimeStatus(DownTimeStatus.InProgress);
    timerRef.current = setInterval(() => {
      setDownTime((val) => {
        const newVal = val - 1;
        if (newVal === 0) {
          setDownTimeStatus(DownTimeStatus.End);
          clearInterval(timerRef.current as NodeJS.Timeout);
        }
        return newVal;
      });
    }, 1000);
  };

  const reSendCodeHandler = async () => {
    try {
      if (loading) return;
      setLoading(true);
      if (downTimeStatus === DownTimeStatus.End) {
        await reSendCode();
        downTimeCount();
      }
    } catch (error: any) {
      showError(error?.message || '');
    }
    setTimeout(() => {
      setLoading(false);
    }, 100);
  };

  useEffect(() => {
    downTimeCount();
    return () => {
      clearInterval(timerRef.current as NodeJS.Timeout);
    };
  }, []);

  return (
    <ReSendCodeWrap>
      {downTimeStatus !== DownTimeStatus.NotStarted && (
        <div>
          {locales.didNotReceiveCode}
          <ReSendCodeDiv $pointer={downTimeStatus === DownTimeStatus.End}>
            {downTimeStatus === DownTimeStatus.InProgress || downTimeStatus === DownTimeStatus.Stop ? (
              `${downTime} s`
            ) : downTimeStatus === DownTimeStatus.End ? (
              <>
                {loading && (
                  <div
                    style={{
                      width: '24px',
                      height: '24px',
                      top: '1px',
                      position: 'relative',
                    }}
                  >
                    <LoadingSpinner spin={true} borderWidth={2}></LoadingSpinner>
                  </div>
                )}
                <div onClick={reSendCodeHandler}>{locales.resendCode}</div>
              </>
            ) : (
              ''
            )}
          </ReSendCodeDiv>
        </div>
      )}
    </ReSendCodeWrap>
  );
};

export default ReSend;
